import { Box, Grid } from "@material-ui/core";
import React from "react";
import FieldDates from "./FieldDates";
import FieldGrouping from "./FieldGrouping";
import { FilterFC } from "./types";

const Filter: FilterFC = ({loading}) => (
  <Box padding={1}>
    <Grid container>
      <FieldDates loading={loading} />
      <FieldGrouping loading={loading} />
    </Grid>
  </Box>
);

export default Filter;
